<template>
  <v-app>
    <!-- sidebar -->
    <v-navigation-drawer light style="border-right:2px #f4f5fa solid; font-family:Oswald;" v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <!-- sidebar-menu -->
          <v-list class="d-flex flex-column ma-0" height="100%">
            
            <img width="120px"  class="mx-auto mt-4" src="/logo.png">
            <v-list-item class="mt-auto px-0">
              <v-spacer>

              <!-- dashboard -->
              <v-tooltip right open-delay="1000" v-if="currentUser.id == 1 || currentUser.id == 92">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item to="/calendar" link v-bind="attrs" v-on="on">
                    <v-list-item-action class="mr-3">
                      <v-icon>mdi-calendar-blank</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Calendario</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>Pantalla de inicio</span>
              </v-tooltip>

              <!-- pacientes -->
              <v-tooltip right open-delay="1000" v-if="currentUser.id == 1 || currentUser.id == 92 || currentUser.id == 237 || currentUser.id == 148">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item to="/clients" link v-bind="attrs" v-on="on">
                    <v-list-item-action class="mr-3">
                      <v-icon>mdi-account-group</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Pacientes</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>Lista de Pacientes</span>
              </v-tooltip>
              
              <!-- menús -->
              <v-tooltip right open-delay="1000" v-if="currentUser.id == 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item to="/foods" link v-bind="attrs" v-on="on">
                    <v-list-item-action class="mr-3">
                      <v-icon>mdi-food-drumstick</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Alimentos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>Asigna planes a tus pacientes</span>
              </v-tooltip>

              <!-- menús -->
              <v-tooltip right open-delay="1000" v-if="currentUser.id == 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item to="/menu" link v-bind="attrs" v-on="on">
                    <v-list-item-action class="mr-3">
                      <v-icon>mdi-food</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Platillos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>Gestion de platillos para dietas</span>
              </v-tooltip>

              <!-- menús -->
              <v-tooltip right open-delay="1000">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item to="/training-plans" link v-bind="attrs" v-on="on">
                    <v-list-item-action class="mr-3">
                      <v-icon>mdi-arm-flex-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Entrenamiento</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>Gestiona entrenamientos por dificultad y grupo(s) musculares</span>
              </v-tooltip>
              
              <!-- videos -->
              <v-tooltip right open-delay="1000">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item to="/videos" link v-bind="attrs" v-on="on">
                    <v-list-item-action class="mr-3">
                      <v-icon>mdi-youtube</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Videos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>Lista de videos para rutinas de entrenamiento</span>
              </v-tooltip>
              
              </v-spacer>
            </v-list-item >
          </v-list>
      <template v-slot:append>
        <div style="color:#9ca3a5; font-size: 12px;" class="pa-2">
          TORsystem | v1.7.1 <v-icon> mdi-settings</v-icon>
        </div>
      </template>
      
    </v-navigation-drawer>

    
    <!-- content -->
    <v-main class="pa-0" style="background:#eeeeee;">
      <v-btn 
      absolute left @click="drawer=!drawer" class="elevation-0" :color="colorBtn" :dark="!drawer" style="min-width: 10px!important; width: 10px; margin-left: -20px; padding: 40px 10px 40px 15px; margin-top: calc(50vh - 100px);">
        <v-icon v-if="drawer">mdi-chevron-left</v-icon>
        <v-icon v-else>mdi-chevron-right</v-icon>
      </v-btn>
      <v-container class="pa-0" fluid>
        <keep-alive>
          <router-view @closeDrawer="closeDrawer"></router-view>
        </keep-alive>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      drawer:true,
    }),
    computed:{
      currentUser:{
        get(){
          return this.$store.state.currentUser.user;
        }
      },
      colorBtn(){
        if(this.drawer){
          return 'white'
        }else{
          return '#e12826'
        }
      },
    },
    created(){
      this.$store.dispatch('plan/getPlans')
      this.$store.dispatch('category/getCategories')
      this.$store.dispatch('currentUser/getUser')
    },
    methods:{
      closeDrawer: function(){
        
      }
    }
  }
</script>


<style>
.theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before {
    opacity: 1!important;
    border-right: 3px #e12826 solid;
    background: transparent;
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled), 
.theme--light.v-icon {
    color: black!important;
    font-weight: 600!important;
}
.v-list .v-list-item--active, .v-list-item--active .theme--light.v-icon, .v-application a  {
    color: #e12826!important;
    font-weight: 600!important;
}
</style>
